var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6606C13.8186 13.6606 15.5628 12.9415 16.8487 11.6616C18.1347 10.3816 18.8571 8.64555 18.8571 6.83538C18.8571 5.02521 18.1347 3.28918 16.8487 2.0092C15.5628 0.729218 13.8186 0.0101318 12 0.0101318C10.1814 0.0101318 8.43723 0.729218 7.15127 2.0092C5.8653 3.28918 5.14286 5.02521 5.14286 6.83538C5.14286 8.64555 5.8653 10.3816 7.15127 11.6616C8.43723 12.9415 10.1814 13.6606 12 13.6606ZM9.55179 16.2201C4.275 16.2201 0 20.4752 0 25.7275C0 26.6019 0.7125 27.3111 1.59107 27.3111H22.4089C23.2875 27.3111 24 26.6019 24 25.7275C24 20.4752 19.725 16.2201 14.4482 16.2201H9.55179Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.40c94e94834975fa56563dd276953e6d.svg";
export { ForwardRef as ReactComponent };